/* v88-pdp-column.js — the ritual panel and the accordion belong to the buy
 * column on desktop.
 *
 * WHY MOVE THEM AT ALL.
 *
 * Both are their own Shopify sections, rendered full width underneath the
 * two-column block, and the stylesheet used to fake their place by pinning
 * their contents to a 722px box on the right-hand side. That reads
 * correctly, but it leaves the grid with two columns of very different
 * heights — and a sticky element can only hold for as long as its own
 * containing block. The gallery therefore let go the moment the buy column
 * ran out: after roughly 700px on OneFit and only 340 on OneLife, which is
 * the shorter page.
 *
 * Moved into the grid, they are simply more of the buy column:
 * `.v88-pdp > *:not(.v88-pdp__hero)` already puts every child into column
 * two, so no placement rules are needed, and the gallery holds for the
 * length of everything above the bundle.
 *
 * A section cannot be rendered inside another section's markup, so this is
 * the one thing CSS cannot do and a few lines of DOM can. Below the
 * breakpoint each node goes back exactly where it was, which is why every
 * mover remembers both its parent and the node it sat in front of.
 */
(function () {
  'use strict';

  var grid = document.querySelector('.v88-pdp');
  if (!grid) return;

  /* The "plus" accordion is a different component on a different page; only
     the buy-box accordion travels. */
  var movers = [];
  /* .vi-tastes: the Vanilla Ice lander's "Tastes Like" + "Packed With"
     panel, the foot of Grüns' buy column (2026-10-02). Only on that page. */
  ['.v88-ritual', '.v88-acc:not(.v88-acc--plus)', '.vi-tastes'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el && el.parentNode) movers.push({ el: el, parent: el.parentNode, next: el.nextSibling });
  });
  if (!movers.length) return;

  var mq = window.matchMedia('(min-width: 992px)');

  function apply() {
    movers.forEach(function (m) {
      var inGrid = m.el.parentNode === grid;
      if (mq.matches && !inGrid) {
        grid.appendChild(m.el);
        /* The section wrapper it came out of is empty now. It carries no
           box of its own, but hiding it means no theme rule can give it
           one and open a gap where the section used to be. */
        m.parent.classList.add('v88-moved-out');
      } else if (!mq.matches && inGrid) {
        m.parent.classList.remove('v88-moved-out');
        m.parent.insertBefore(m.el, m.next);
      }
    });
    /* Everything below these two has shifted, and the scroll animations
       measured their trigger points against the old layout. */
    if (window.AOS && typeof window.AOS.refresh === 'function') window.AOS.refresh();
  }

  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();
